import * as React from "react";
import { Dialog, dialog, Button } from "@stemscopes/ui";
import Icon from "../icon";
import styles from "./Dialog.module.css";

dialog.setConfig({
  overlay: true,
  className: styles.wrapper,
  headerClassName: styles.header,
  overlayClassName: styles.overlay,
  contentClassName: styles.content,
  closeButton: (
    <Button
      iconOnly
      size="medium"
      variant="clear"
      title="Сlose dialog window"
      className={styles.buttonClose}
      prefix={<Icon name="close-outlined" />}
    />
  ),
});

export { Dialog, dialog };
